import { NavSchema } from './Nav.styles';

export const navStyles: NavSchema = {
  wrapper: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    bg: 'blackAlpha.400',
    w: ['100% + 8px', null, '100%'],
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 1px 5px 0px rgba(0, 0, 0, 0.25) inset',
    borderRadius: ['none', null, 'md'],
    minH: '9',
    h: 'auto',
    px: '4',
    mx: ['-2', null, '0'],
    my: '3',
    sx: {
      '&[data-isonsportsall="true"]': {
        pb: '0',
        borderBottom: 'none',
      },
    },
  },
  link: {
    boxShadow: 'none',
    border: 'none',
    fontSize: 'sm',
    borderRadius: 'none',
    fontFamily: 'Staatliches',
    lineHeight: '2',
    h: '10',
    color: 'white',
    borderBottom: '3px solid',
    borderBottomColor: 'transparent',
    textTransform: 'uppercase',
    px: '3',
    pt: '1.5',
    pb: '1',
    sx: {
      '&.active': {
        border: 'none',
        borderBottom: '3px solid',
        color: 'beta.300',
        borderBottomColor: 'beta.300',
      },
    },
  },
};
